import styles from "./SubmitButton.module.css";

const SubmitButton = ({
  children,
  loading = false,
  disabled = false,
  type = "submit",
  className = "",
  icon = null,
}) => {
  return (
    <button
      type={type}
      disabled={loading || disabled}
      className={`${styles.button} ${className}`}
    >
      {loading ? (
        <span className={styles.spinner}></span>
      ) : (
        icon && (
          <span className={styles.icon}>
            {icon}
          </span>
        )
      )}

      <span>
        {loading ? "در حال ثبت..." : children}
      </span>
    </button>
  );
};

export default SubmitButton;